import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import ReviewList from 'components/Review/List';

const ScreenReviewList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <ReviewList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenReviewList;
